var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4414 10C22.3122 10.0001 23.0826 10.5637 23.3467 11.3936L23.5605 12.0645H26.5811C27.6854 12.0647 28.581 12.96 28.5811 14.0645V24C28.5811 25.1044 27.6854 25.9998 26.5811 26H12C10.8954 26 10 25.1046 10 24V14.0645C10 12.9599 10.8955 12.0645 12 12.0645H14.9268L15.1992 11.3164C15.4867 10.5261 16.2381 10 17.0791 10H21.4414ZM19.5479 14.6465C17.1253 14.6467 15.1614 16.6106 15.1611 19.0332C15.1611 21.3803 17.0044 23.2974 19.3223 23.415L19.5479 23.4209C21.8949 23.4209 23.812 21.5776 23.9297 19.2598L23.9355 19.0332C23.9353 16.6105 21.9706 14.6465 19.5479 14.6465ZM19.5479 15.6465C21.4183 15.6465 22.9353 17.1628 22.9355 19.0332C22.9355 20.9038 21.4185 22.4209 19.5479 22.4209C17.6774 22.4207 16.1611 20.9037 16.1611 19.0332C16.1614 17.1629 17.6775 15.6467 19.5479 15.6465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0fa0b6fc85aa282b87d840b05ddf6be6.svg";
export { ForwardRef as ReactComponent };